import React, { Component } from "react";
import {
  pendenciasDoDia,
  ListaVendedoresAtivos,
  runVerificaAutenticacao,
  ListaTelasCRM,
} from "../../../services/api";
import GridTable from "../../../lib/GridTable";
import $ from "jquery";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Header from "../../../components/Header";
import {
  ButtonFilter,
  ContentFilter,
  ContentFilterSelectVendedor,
  ContentLoading,
  ContentLoadingContent,
  ContentTables,
  ContentTablesHighlights,
  ContentTablesItem,
  ContentTablesName,
  PendenciasDoDiaContainer,
  PendenciasDoDiaContainerText,
  SelectBox,
} from "./styles";
import { Box, Image } from "@chakra-ui/react";

const loading = "/images/loading-verde.gif";

class PendenciasDoDia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStart: "",
      dataEnd: "",
      dados: [],
      dadosTotal: [],
      proposta_selecionada: [],
      vendedores: [],
      usuario_selecionado: null,
      view_loading: false,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication"))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.initial();
  }

  initial = async () => {
    await this.CarregaPermissoes();

    if ([0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario)) {
      this.getConfig();
    } else {
      this.getVendedores();
      this.getLessons();
    }
  };

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        "/" + window.location.pathname.replace("/", "")
      );
      var data = response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].consulta,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getConfig = async () => {
    const queryParams = new URLSearchParams(window.location.search);

    const vendedor = queryParams.get("v");

    await this.getVendedores();

    if (vendedor != null) {
      $("#selectVendedor").val(vendedor);
      await this.setState({ usuario_selecionado: vendedor });
    }

    this.getLessons();
  };

  getVendedores = async () => {
    try {
      const response = await ListaVendedoresAtivos.get();
      var data = response.data;

      var vendedores = [];
      data.map((data) => {
        vendedores.push({
          value: data.codigo_usuario,
          label: data.nome_vendedor,
        });
      });

      this.setState({ vendedores: vendedores });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getLessons = async () => {
    if (this.state.control_consulta != "S") {
      alert("Permissão negada");
      return false;
    }

    const user =
      this.state.usuario_selecionado != null
        ? this.state.usuario_selecionado
        : this.state.codigo_usuario;

    try {
      this.setState({ view_loading: true });
      const response = await pendenciasDoDia.get("/" + user);

      const dados = response.data.splice(0, response.data.length - 1);
      const dadosTotal = response.data.splice(-1, 1);

      this.setState({
        dados: dados,
        dadosTotal: dadosTotal,
        view_loading: false,
      });
    } catch (error) {
      this.setState({ view_loading: false });
      console.log(Object.keys(error), error.message);
    }
  };

  openProposta = async (e) => {
    var value = e.target.attributes.value.value;

    if (this.state.proposta_selecionada.includes(value)) {
      var propostas = [];
      this.state.proposta_selecionada.map((data) => {
        if (data != value) {
          propostas.push(value);
        }
      });
      this.setState({ proposta_selecionada: propostas });
    } else {
      var propostas = this.state.proposta_selecionada;
      propostas.push(value);
      this.setState({ proposta_selecionada: propostas });
    }

  };

  filtrarDadosVendedor = async () => {
    await this.setState({ dados: [] });
    this.getLessons();
  };

  selectUsuario = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    await this.setState({ usuario_selecionado: option });
  };

  render() {
    const { dados, dadosTotal, vendedores, dateStart, endDate } = this.state;

    function rankFormatter(cell, formatExtraData) {
      return <div className={formatExtraData[cell]}></div>;
    }

    function checkFormatter(cell, formatExtraData) {
      return <div className={formatExtraData[cell]}></div>;
    }

    function priceFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "";
      return atual;
    }

    function integerFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            minimumIntegerDigits: 2,
            minimumFractionDigits: 0,
          })
        : "";
      return atual;
    }

    const columns = [
      {
        dataField: "qualificacao",
        text: "Qualificação",
        formatter: rankFormatter,
        formatExtraData: {
          0: "rating rating-0_star-orange",
          1: "rating rating-1_star-orange",
          2: "rating rating-2_star-orange",
          3: "rating rating-3_star-orange",
        },
      },
      {
        dataField: "pedido_especial",
        text: "Proposta especial",
        formatter: checkFormatter,
        formatExtraData: {
          S: "icon icon-25 icon-check-orange",
          N: "icon icon-25 icon-uncheck-orange",
        },
        sort: true,
      },
      {
        dataField: "codigo_proposta",
        text: "Proposta",
        sort: true,
      },
      {
        dataField: "tipo_proposta",
        text: "Tipo de proposta",
        sort: true,
      },
      {
        dataField: "nome_cliente",
        text: "Cliente",
      },
      {
        dataField: "codigo_parceiro",
        text: "Código parceiro",
        sort: true,
      },
      {
        dataField: "nome_contato",
        text: "Contato",
        sort: true,
      },
      {
        dataField: "email_contato",
        text: "E-mail",
        sort: true,
      },
      {
        dataField: "telefone_parceiro",
        text: "Telefone",
        sort: true,
      },
      {
        dataField: "data_abertura",
        text: "Abertura do chamado",
        sort: true,
      },
      {
        dataField: "data_primeiro_contato",
        text: "Primeiro contato",
        sort: true,
      },
      {
        dataField: "data_proposta_encaminhada",
        text: "Proposta encaminhada",
        sort: true,
      },
      {
        dataField: "feedback_proposta",
        text: "Feedback da proposta",
        sort: true,
      },
      {
        dataField: "data_encaminhamento_layout",
        text: "Encaminhado layout",
        sort: true,
      },
      {
        dataField: "analise_fechamento",
        text: "Análise para fechamento",
        sort: true,
      },

      {
        dataField: "",
        text: "Abrir proposta",
        element: (
          <a href={``}>
            <span className="icon icon-20 icon-folder-orange"></span>
          </a>
        ),
      },
    ];

    return (
      <>
        <PendenciasDoDiaContainer>
          <PendenciasDoDiaContainerText>
            <h1>
              PENDÊNCIAS DO<strong> DIA</strong>
            </h1>
          </PendenciasDoDiaContainerText>
          <Box>
            <ContentLoading
              style={
                this.state.view_loading
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <ContentLoadingContent>
                <Image src={loading} />
              </ContentLoadingContent>
            </ContentLoading>
            {[0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario) ? (
              <ContentFilter>
                <ContentFilterSelectVendedor>
                  <SelectBox
                    bgColor="white"
                    color="gray.500"
                    iconColor="#ff9045"
                    fontSize="20px"
                    variant="outline"
                    focusBorderColor="#ff9045"
                    _hover={{ borderBottomColor: "#ff9045" }}
                    _active={{ borderBottomColor: "#ff9045" }}
                    placeholder="Vendedores..."
                    id={"selectVendedor"}
                    onChange={(e) => this.selectUsuario(e)}
                  >
                    {vendedores.map((data) => {
                      return <option value={data.value}>{data.label}</option>;
                    })}
                  </SelectBox>
                </ContentFilterSelectVendedor>
                <ButtonFilter
                  onClick={() => this.filtrarDadosVendedor()}
                  className="innovation-crm-pendencias-do-dia-container__content__filter__btn"
                >
                  Aplicar
                </ButtonFilter>
              </ContentFilter>
            ) : (
              <></>
            )}

            <ContentTables>
              <ContentTablesHighlights>
                {dadosTotal.map((dado) => (
                  <>
                    <ContentTablesItem>
                      <ContentTablesName>
                        TOTAL DE PENDÊNCIAS DO DIA:{" "}
                        <strong> {dado.codigo_proposta}</strong>
                      </ContentTablesName>
                    </ContentTablesItem>
                  </>
                ))}
              </ContentTablesHighlights>

              {dados.length > 0 ? (
                <GridTable columns={columns} dados={this.state.dados} />
              ) : (
                <></>
              )}
            </ContentTables>
          </Box>
        </PendenciasDoDiaContainer>
      </>
    );
  }
}

export default PendenciasDoDia;
